import React from 'react';
import PropTypes from 'prop-types';

import TpLeadLeftColumn from './TpLeadLeftColumn';
import TpLeadRightColumn from './TpLeadRightColumn';
import s from './toipRowLayout.scss';

const ToipRowLayout = props => {
  const { data, userData } = props;

  if (!data?.items || !data.items?.length) {
    return null;
  }

  const Renderer = () => {
    let leftComponent = null;
    let rightComponent = null;
    // eslint-disable-next-line array-callback-return
    data.items.map(el => {
      switch (el.tn) {
        case 'tplead_col_8_list': {
          leftComponent = (
            <TpLeadLeftColumn item={el.items} userData={userData} />
          );
          break;
        }
        case 'tplead_col_4_list': {
          rightComponent = (
            <TpLeadRightColumn item={el.items} userData={userData} />
          );
          break;
        }
        default: {
          leftComponent = null;
          rightComponent = null;
        }
      }
    });
    return (
      <div className={s.layout}>
        {leftComponent}
        {rightComponent}
      </div>
    );
  };

  return <Renderer />;
};

ToipRowLayout.propTypes = {
  data: PropTypes.objectOf(PropTypes.object),
  userData: PropTypes.shape({}),
};

ToipRowLayout.defaultProps = {
  data: {},
  userData: undefined,
};
export default ToipRowLayout;
